import { render, staticRenderFns } from "./PreVerificationDialog.vue?vue&type=template&id=63a71b68&scoped=true"
import script from "./PreVerificationDialog.vue?vue&type=script&lang=js"
export * from "./PreVerificationDialog.vue?vue&type=script&lang=js"
import style0 from "./PreVerificationDialog.vue?vue&type=style&index=0&id=63a71b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a71b68",
  null
  
)

export default component.exports